export const DOCUMENT_TYPE_FORMS_AGREEMENTS = "FORMS_AGREEMENT";
export const DOCUMENT_TYPE_NOTICES_LETTERS = "NOTICES_LETTERS";
export const DOCUMENT_TYPE_FINANCIAL_STATEMENT_LETTER = "FINANCIAL_STATEMENT_LETTER";
export const DOCUMENT_TYPE_SURETY_BONDS = "SURETY_BONDS";
export const DOCUMENT_TYPE_CRIMINAL_RECORD = "CRIMINAL_RECORD";
export const DOCUMENT_TYPE_EDUCATION_CERTIFICATE = "EDUCATION_CERTIFICATE";
export const DOCUMENT_TYPE_CONTINUING_EDUCATION_CERTIFICATE = "CONTINUING_EDUCATION_CERTIFICATE";
export const DOCUMENT_TYPE_INSURANCE_PROOF = "INSURANCE_PROOF";
export const DOCUMENT_TYPE_INSURANCE_CONTINURATION = "INSURANCE_CONTINUATION";
export const DOCUMENT_TYPE_WORK_EXPERIENCE = "WORK_EXPERIENCE";
export const DOCUMENT_TYPE_ANNUAL_INFORMATION_RETURN = "ANNUAL_INFORMATION_RETURN";
export const DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE = "BROKER_COURSE_CERTIFICATE";

export const DOCUMENT_CONTENT_TYPE_PDF = "PDF";
export const DOCUMENT_CONTENT_TYPE_DOC = "DOC";
export const DOCUMENT_CONTENT_TYPE_XLS = "XLS";
export const DOCUMENT_CONTENT_TYPE_DOCX = "DOCX";
export const DOCUMENT_CONTENT_TYPE_XLSX = "XLSX";

export const MORTGAGE_BROKERAGE_DOCUMENT_TYPES_MAP = {
  [DOCUMENT_TYPE_INSURANCE_PROOF]: "Insurance Proof",
  [DOCUMENT_TYPE_INSURANCE_CONTINURATION]: "Insurance Continuation",
  [DOCUMENT_TYPE_CRIMINAL_RECORD]: "Criminal Record Check"
};

export const MORTGAGE_BROKER_DOCUMENT_TYPES_MAP = {
  [DOCUMENT_TYPE_EDUCATION_CERTIFICATE]: "Education Certificate",
  [DOCUMENT_TYPE_CONTINUING_EDUCATION_CERTIFICATE]: "Continuing Education Certificate",
  [DOCUMENT_TYPE_CRIMINAL_RECORD]: "Criminal Record Check",
  [DOCUMENT_TYPE_WORK_EXPERIENCE]: "Work Experience",
  [DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE]: "Broker Course Certificate"
};

export const MORTGAGE_ASSOCCIATE_BROKER_DOCUMENT_TYPES_MAP = {
  [DOCUMENT_TYPE_EDUCATION_CERTIFICATE]: "Education Certificate",
  [DOCUMENT_TYPE_CONTINUING_EDUCATION_CERTIFICATE]: "Continuing Education Certificate",
  [DOCUMENT_TYPE_CRIMINAL_RECORD]: "Criminal Record Check",
  [DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE]: "Broker Course Certificate"
};

export const MORTGAGE_LENDER_DOCUMENT_TYPES_MAP = {
  [DOCUMENT_TYPE_INSURANCE_PROOF]: "Insurance Proof",
  [DOCUMENT_TYPE_INSURANCE_CONTINURATION]: "Insurance Continuation",
  [DOCUMENT_TYPE_CRIMINAL_RECORD]: "Criminal Record Check"
};

export const COLLECTION_AGENCY_DOCUMENT_TYPES_MAP = {
  [DOCUMENT_TYPE_NOTICES_LETTERS]: "Notices and Letters",
  [DOCUMENT_TYPE_FORMS_AGREEMENTS]: "Forms and Agreements",
  [DOCUMENT_TYPE_SURETY_BONDS]: "Surety Bond"
};

export const DEBT_MANAGEMENT_DOCUMENT_TYPES_MAP = {
  [DOCUMENT_TYPE_NOTICES_LETTERS]: "Notices and Letters",
  [DOCUMENT_TYPE_FORMS_AGREEMENTS]: "Forms and Agreements"
};
